/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * BBook trade response
 */
export interface BBookOrderResponse {
  /**
   * Order ID.
   */
  orderId: number;
}
